<script setup lang="ts">
interface Props {
    /** Use 'strong' for the darker variant */
    variant?: 'default' | 'strong';
}

withDefaults(defineProps<Props>(), {
    variant: 'default',
});
</script>

<template>
    <div
        :class="[
            'mb-4 flex items-center gap-3 rounded border border-l-[3px] border-border border-l-foreground/40 px-3.5 py-3 text-[13px] text-foreground',
            $props.variant === 'strong' ? 'bg-accent' : 'bg-muted',
        ]"
    >
        <!-- Icon slot or default "IA" circle -->
        <div
            class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-foreground text-[10px] font-semibold tracking-[0.04em] text-background"
        >
            <slot name="icon">IA</slot>
        </div>

        <!-- Text content -->
        <div class="flex-1">
            <slot />
        </div>

        <!-- Optional action (button/link) -->
        <div v-if="$slots.action" class="shrink-0">
            <slot name="action" />
        </div>
    </div>
</template>
